import { useState } from "react";
import axios from "axios";
import labels from "../../../../config/labels";
import config from "../../../../config/index";
import * as Analytics from "../../../../services/analyticsUtag";
import {
  CustomContainer,
  Container,
  Row,
  Col,
  useRouter,
  connect,
} from "../../../atoms/DependencyHelper";
import {
  showSpinner,
  hideSpinner,
  getOrderTypeAndLabel,
  orderPageButtons,
  generateOrderCSSVariant,
  generateOrderIconVariant,
  getOrderBlurb,
  getCookieValue,
  componentCheckSize,
  setCookieConsentWrapper,
  getTrackingUrl,
  getDisplayedRange,
  getOrderProductImageUrl,
  getDealPrice,
  isOnceOffOrder,
  isDealOrder,
  isMultiOrder,
} from "../../../../utils/helperServices";
import {
  setNormalCheckoutCurrentStep,
  setPostCheckoutCurrentStep,
} from "../../../../Redux/actions/checkoutAction";
import paymentServices from "../../../../utils/paymentIntegrationServices";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import { productOrderReq } from "../../../../data/mockRenderComponent";
import OrderHistoryLoadMore from "../orderHistoryLoadMore/OrderHistoryLoadMore";
import Image from "../../../atoms/image/image";

import styles from "./OrderHistoryList.module.scss";

const OrderHistoryList = (props) => {
  const router = useRouter();
  const authToken = getCookieValue("auth_token");
  const vodAuthToken = getCookieValue("vod-web-auth-token");

  const [postOrderData, setPostOrderData] = useState({});
  const [selectedIncrementId, setSelectedIncrementId] = useState(null);
  const [paymentUrl, setPaymentUrl] = useState(null);

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const shoppingUrlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const paymentCallbackUrl = config.envConfigs[env].paymentCallback;
  const postPaymentCallbackUrl = config.envConfigs[env].postPaymentCallback;
  const paymentProvision = config.envConfigs[env].paymentProvision;
  const paymentConfig = props?.paymentConfiguration;

  const isTablet = componentCheckSize() <= 992;
  const currentPage = props?.pageInfo?.current_page;
  const totalLength = props?.dataList?.length;
  const totalPages = props?.pageInfo?.total_pages;
  const FilterText = getDisplayedRange(
    totalLength,
    props?.totalItemsCount,
    labels.lbl_past_orders_found
  );

  const increasePageCount = () => {
    if (currentPage < totalPages) {
      props.updateCurrentPage(currentPage + 1);
    }
  };

  const generateVariant = (orderStatus) => {
    return `${styles["order-status"]} ${
      styles[generateOrderCSSVariant(orderStatus)]
    }`;
  };

  const onOrderClick = (event, detail) => {
    Analytics.link({
      ...Analytics.getUtagData(),
      link_type: "o",
      link_name: "checkout: order history: view order details",
      order_type: "once off purchase",
      order_status: "in progress",
      sales_order_id: detail,
    });
    showSpinner();
    router.push({
      pathname: `${shoppingUrlPrefix}/view-order-details/${detail}`,
    });
  };

  const handleTrackOrder = (orderId, waybillNumber) => {
    Analytics.link({
      ...Analytics.getUtagData(),
      link_type: "o",
      link_name: "checkout: order history: track order",
      order_type: "once off purchase",
      order_status: "in progress",
      sales_order_id: orderId,
    });
    showSpinner();
    router.push({
      pathname: getTrackingUrl(waybillNumber, orderId),
    });
  };

  const orderRouter = (orderResult) => {
    showSpinner();
    let postOrder = JSON.parse(
      JSON.stringify(productOrderReq).replace(/\:null/gi, ':""')
    ); //replace null with "" for all attributes
    let headers = {};
    if (vodAuthToken) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-jwt": `Bearer ${vodAuthToken}`,
        "x-magento-token": `Bearer ${authToken}`,
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
    }
    const url = `${config.envConfigs[config.env].dxl.url}${
      config["api"]["postpaidProductOrder"]
    }`;

    postOrder.productOrder[0].productOrderState = orderResult?.status;
    postOrder.productOrder[0].productOrderId = orderResult?.increment_id;
    postOrder.productOrder[0].orderReference = orderResult?.waybill_number
      ? orderResult.waybill_number
      : "";
    axios
      .post(url, postOrder, {
        headers: headers,
      })
      .then((response) => {
        const { data } = response || {};
        if (data && data?.productOrders?.length) {
          setPostOrderData(data.productOrders[0]);
          setCookieConsentWrapper(
            `cookie_${config.order_id}`,
            [config.cookie_category.strictly_necessary],
            `document.cookie='${config.order_id}=${data.productOrders[0].productOrderId};path=/'`
          );

          if (props.isMiniApp) {

            router.push(`/shopping/mini-app/retry-payment/${orderResult?.increment_id}`);
            return;
          }

          if (props.paymentOptionsEnabled) {
            const redirectUrl = isMultiOrder(orderResult?.order_type)
              ? postPaymentCallbackUrl
              : paymentCallbackUrl;
            getIntentData(
              orderResult,
              data.productOrders[0].productOrderId,
              redirectUrl
            );
          } else {
            redirectToPayment(orderResult);
          }
        } else {
          hideSpinner();
          handleApiFailure(orderResult?.increment_id, orderResult?.order_type);
        }
      })
      .catch(() => {
        hideSpinner();
        handleApiFailure(orderResult?.increment_id, orderResult?.order_type);
      });
  };

  const getIntentData = async (orderResult, productOrderId, redirectUrl) => {
    paymentServices
      .getPaymentIntent(productOrderId, redirectUrl)
      .then((res) => {
        if (!res.fail && res.response?.data) {
          setPaymentUrl(res.response.data?.paymentUrl);
        } else {
          Analytics.link({
            ...Analytics.getUtagData(["page_name"]),
            page_form_event: "error",
            page_errors: `${
              res?.error?.data?.result?.message
                ? res.error.data.result.message
                : res?.error?.data?.message
                ? res.error.data.message
                : ""
            }`,
            page_errors_code: `chk-dxl-g-id-${res?.error?.status}`,
          });
        }

        redirectToPayment(orderResult);
      })
      .catch((err) => {
        if (err) {
          Analytics.link({
            ...Analytics.getUtagData(["page_name"]),
            page_form_event: "error",
            page_errors: `${err.message ? err.message : ""}`,
            page_errors_code: `chk-dxl-g-id-${err?.response?.status}`,
          });
        }
        redirectToPayment(orderResult);
      });
  };

  const redirectToPayment = (orderResult) => {
    const form_element = document.getElementById(orderResult?.increment_id);
    const child_node = form_element?.childNodes;
    window.setTimeout(child_node?.[0]?.submit.bind(child_node?.[0]), 800);
  };

  const handleApiFailure = (id, orderType) => {
    setCookieConsentWrapper(
      `cookie_${config.order_id}`,
      [config.cookie_category.strictly_necessary],
      `document.cookie='${config.order_id}=${id};path=/'`
    );

    if (isMultiOrder(orderType)) {
      props?.setPostCheckoutCurrentStep("paymentError");
    } else {
      props?.setNormalCheckoutCurrentStep("paymentError");
    }

    window.location.href = isMultiOrder(orderType)
      ? `${shoppingUrlPrefix}/post-checkout`
      : `${shoppingUrlPrefix}/checkout`;
  };

  const handleSubmit = (event, item) => {
    event.preventDefault();
    setSelectedIncrementId(item?.increment_id);
    orderRouter(item);
  };

  const displayTrackOrderBtn = (item) => {
    const trackBtn = orderPageButtons(item.status).displayTrackOrderBtn;
    if (isOnceOffOrder(item.order_type)) return trackBtn;
    return props?.trackOrderEnabled && trackBtn;
  };

  const getExtraSpaceClass = (item) => {
    const msg = getOrderBlurb(item?.status);
    return msg ? "" : "empty-block";
  };

  const renderBlurbMsg = (item) => {
    const msg = getOrderBlurb(item?.status);
    return (
      msg && (
        <CustomContainer className={styles["blurb-message"]}>
          <CustomContainer className={`${styles["blurb-message--inner"]}`}>
            {msg}
          </CustomContainer>
        </CustomContainer>
      )
    );
  };

  const renderOrderImage = (item) => {
    const images = getOrderProductImageUrl(item, "image", "No_image");
    return (images || []).map((imgItem, index1) => (
      <CustomContainer
        key={`order-image-${item?.increment_id}-${index1}`}
        className={`${styles["rectangle"]} d-inline-block`}
      >
        <img src={imgItem} alt="productThumb" />
      </CustomContainer>
    ));
  };

  return (
    <>
      <CustomContainer className={`${styles["order-list"]} mb-l`}>
        {isTablet && (
          <Container className={`${styles["order-list-pagination"]}`}>
            {FilterText}
          </Container>
        )}
        {props?.dataList?.map(
          (item, index) =>
            item?.status !== "CREATE_MAGENTO_SUCCESS" && (
              <Container key={index} id={`order-card-${index}`}>
                <CustomContainer className={`${styles["order-card-col"]}`}>
                  <Row className="mx-0">
                    <Col
                      className={`${styles["left-col"]} pl-0 pr-0`}
                      lg={8}
                      md={9}
                    >
                      <CustomContainer
                        className={`${styles["order-number-block"]}`}
                      >
                        <Image
                          img_path={`${imagePrefix}/assets/images/${generateOrderIconVariant(
                            item.status
                          )}`}
                          img_width="1.875rem"
                          img_height="1.875rem"
                          className="order-status-icon"
                        />
                        <span className={`${styles["order-number"]}`}>
                          {labels.lbl_order_number_hash}
                          {item.increment_id}
                        </span>
                      </CustomContainer>
                      <CustomContainer
                        className={`${styles["type-block"]} ${
                          styles[getExtraSpaceClass(item)]
                        }`}
                      >
                        {item?.order_type.map((orderTypeItem, index2) => (
                          <span
                            key={index2}
                            className={`${styles["product-type"]}`}
                          >
                            {orderTypeItem}
                          </span>
                        ))}
                        {getOrderTypeAndLabel(item.status).orderStatusLabel !==
                          "" && (
                          <span className={generateVariant(item.status)}>
                            {getOrderTypeAndLabel(item.status).orderStatusLabel}
                          </span>
                        )}
                      </CustomContainer>
                      {renderBlurbMsg(item)}
                      <CustomContainer className={styles["product-thumb-img"]}>
                        {renderOrderImage(item)}
                      </CustomContainer>
                    </Col>
                    <Col
                      className={`${styles["right-col"]} pl-0 pr-0 ${styles["custom-history-view-tablet"]}`}
                      lg={4}
                      md={3}
                    >
                      <CustomContainer>
                        {(isDealOrder(item.order_type) ||
                          !isOnceOffOrder(item.order_type)) &&
                          item?.monthly_recurring && (
                            <CustomContainer
                              className={`${styles["order-total-box"]} mb-s d-flex ${styles["custom-history-price"]} ${styles["custom-history-button"]} ${styles["order-row-total-monthly"]}`}
                            >
                              <span
                                className={`${styles["order-monthly-total-lbl"]}`}
                              >
                                {labels.lbl_order_monthly_total}
                              </span>
                              <span
                                className={`${styles["order-total"]} ${styles["order-total-monthly"]} float-right`}
                              >
                                {getDealPrice(item)}
                              </span>
                            </CustomContainer>
                          )}
                        {(isOnceOffOrder(item.order_type) ||
                          isMultiOrder(item.order_type)) &&
                          item?.grand_total && (
                            <CustomContainer
                              className={`${styles["order-total-box"]} mb-s d-flex ${styles["custom-history-price"]} ${styles["custom-history-button"]}`}
                            >
                              <span className={`${styles["order-total-lbl"]}`}>
                                {labels.lbl_order_once_off_total}
                              </span>
                              <span
                                className={`${styles["order-total"]} ${styles["order-total-once-off"]} float-right`}
                              >
                                {item?.grand_total}
                              </span>
                            </CustomContainer>
                          )}
                      </CustomContainer>
                      <CustomContainer
                        className={`${styles["order-btn-list"]} d-flex`}
                      >
                        <CTAButton
                          variant="outline black"
                          handleClick={(event) =>
                            onOrderClick(event, item.increment_id)
                          }
                          className={`${styles["order-detail-btn"]} btn-outline-dark ${styles["custom-history-button"]}`}
                          id={`${labels.lbl_view_order_details}--btn`}
                        >
                          <label>{labels.lbl_view_order_details}</label>
                        </CTAButton>
                        {displayTrackOrderBtn(item) ? (
                          <CTAButton
                            varian="solid grey"
                            className={`${styles["track-btn"]} mb-xs ${styles["custom-history-button"]}`}
                            handleClick={() =>
                              handleTrackOrder(
                                item.increment_id,
                                item.waybill_number
                              )
                            }
                            id={labels.lbl_track_this_order}
                          >
                            <label>{labels.lbl_track_this_order}</label>
                          </CTAButton>
                        ) : (
                          ""
                        )}
                        {orderPageButtons(item.status).displayRetryOrderBtn ? (
                          <>
                            <CTAButton
                              varian="solid grey"
                              className={`${styles["track-btn"]} mb-xs ${styles["custom-history-button"]}`}
                              handleClick={(event) => handleSubmit(event, item)}
                            >
                              <label>{labels.lbl_retry_payment_order}</label>
                            </CTAButton>
                            {item?.increment_id === selectedIncrementId && (
                              <div id={item?.increment_id}>
                                <form
                                  method="post"
                                  name="ucfCheckout"
                                  id="ucfCheckout"
                                  onSubmit={(event) =>
                                    handleSubmit(event, item)
                                  }
                                  action={
                                    props.paymentOptionsEnabled && paymentUrl
                                      ? paymentUrl
                                      : paymentConfig.paymentGatewayUrl
                                  }
                                >
                                  <input
                                    type="hidden"
                                    name="PayserverUser"
                                    id="PayserverUser"
                                    value={paymentConfig.payServerUser}
                                  />
                                  <input
                                    type="hidden"
                                    name="transactionStatusCallbackUrl"
                                    id="transactionStatusCallbackUrl"
                                    value={paymentConfig.transactionStatusCallbackUrl}
                                  />
                                  <input
                                    type="hidden"
                                    name="transactionCompletedUrl"
                                    id="transactionCompletedUrl"
                                    value={
                                      isMultiOrder(item.order_type)
                                        ? postPaymentCallbackUrl
                                        : paymentCallbackUrl
                                    }
                                  />
                                  <input
                                    type="hidden"
                                    name="redirectURL"
                                    id="redirectURL"
                                    value={
                                      isMultiOrder(item.order_type)
                                        ? postPaymentCallbackUrl
                                        : paymentCallbackUrl
                                    }
                                  />
                                  <input
                                    type="hidden"
                                    name="failureURL"
                                    id="failureURL"
                                    value={
                                      isMultiOrder(item.order_type)
                                        ? postPaymentCallbackUrl
                                        : paymentCallbackUrl
                                    }
                                  />
                                  <input
                                    type="hidden"
                                    name="TransactionStatusCallbackFormat"
                                    id="TransactionStatusCallbackFormat"
                                    value={
                                      paymentConfig.transactionStatusCallbackFormat
                                    }
                                  />
                                  <input
                                    type="hidden"
                                    name="TransactionStatusCallbackMethod"
                                    id="TransactionStatusCallbackMethod"
                                    value={
                                      paymentConfig.transactionStatusCallbackMethod
                                    }
                                  />
                                  <input
                                    type="hidden"
                                    name="MerchantReference"
                                    id="MerchantReference"
                                    value={postOrderData?.productOrderId}
                                  />
                                  <input
                                    type="hidden"
                                    name="Currency"
                                    id="Currency"
                                    value={paymentConfig.currency}
                                  />
                                  <input
                                    type="hidden"
                                    name="TransactionType"
                                    id="TransactionType"
                                    value={paymentConfig.transactionType}
                                  />
                                  <input
                                    type="hidden"
                                    name="MerchantIdentifier"
                                    id="MerchantIdentifier"
                                    value={paymentConfig.merchantIdentifier}
                                  />
                                  <input
                                    type="hidden"
                                    name="CustomerIdentifier"
                                    id="CustomerIdentifier"
                                    value={props?.customerIdentifier}
                                  />
                                  <input
                                    type="hidden"
                                    name="EncXML"
                                    id="EncXML"
                                    value={
                                      postOrderData?.payment
                                        ?.encryptedPaymentDetails
                                    }
                                  />
                                  <input
                                    type="hidden"
                                    name="EncType"
                                    id="EncType"
                                    value={paymentConfig.encType}
                                  />
                                  <input
                                    type="submit"
                                    className={`${styles["track-btn-hidden"]}`}
                                    name={labels.lbl_complete_this_order}
                                    value={labels.lbl_complete_this_order}
                                  />
                                </form>
                              </div>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </CustomContainer>
                    </Col>
                  </Row>
                </CustomContainer>
              </Container>
            )
        )}
        <Container>
          <Row className={props?.isMobile && "mx-0"}>
            <OrderHistoryLoadMore
              pageInfo={props?.pageInfo}
              pageNumber={props?.pageInfo?.current_page}
              totalPages={totalPages}
              onLoadMore={increasePageCount}
            />
          </Row>
        </Container>
      </CustomContainer>
    </>
  );
};

const mapDispatchToProps = {
  setNormalCheckoutCurrentStep,
  setPostCheckoutCurrentStep,
};

const mapStateToProps = (state) => ({
  isMiniApp: state.navDetails.isMiniApp,
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistoryList);
